module.exports = __webpack_public_path__ + "img/thd.7a22b5d2.png";